export default __webpack_public_path__ + "static/media/sa-icon-active.a624eb26.svg";